import React from 'react';
import ProductLink from '@jetshop/ui/ProductLink';
const SuggestedTerm = ({ product, 
// @ts-ignore
term = '', className = '', onClick = () => { } }) => (React.createElement("li", { className: className, onClick: onClick }, product.primaryRoute ? (React.createElement(ProductLink, { product: product }, getHighlightedText(product.name, term))) : (product.name)));
export default SuggestedTerm;
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function getHighlightedText(text, highlight) {
    // Split on higlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${escapeRegExp(highlight)
        .split(' ')
        .join('|')})`, 'gi'));
    const highlightArray = highlight.split(' ');
    const toHighlightLower = highlightArray.map(word => word.toLowerCase());
    return parts.reduce((prev, curr, index) => {
        return [
            ...prev,
            toHighlightLower.includes(curr.toLowerCase()) ? (React.createElement("strong", { style: { fontWeight: 600 }, key: index }, curr)) : (curr)
        ];
    }, []);
}
//# sourceMappingURL=SuggestedTerm.js.map